import { useMemo } from 'react'

import {
  useDeviceIncidentsQuery,
  useDeviceQuery,
} from '@/graphql/generated/hooks'

export const useDeviceDrawerData = (deviceId: string) => {
  const { data: deviceData, loading: isDeviceLoading } = useDeviceQuery({
    variables: { id: deviceId },
    nextFetchPolicy: 'network-only',
  })
  const { data: incidentsData, loading: isIncidentsLoading } =
    useDeviceIncidentsQuery({
      variables: { filter: { deviceIdIn: [deviceId] } },
      nextFetchPolicy: 'network-only',
    })

  const isLoading = !deviceData || isDeviceLoading
  const device = deviceData?.device
  const incidents = useMemo(
    () => incidentsData?.incidents?.edges?.map((i) => i?.node) ?? [],
    [incidentsData]
  )

  return { device, incidents, isLoading, isIncidentsLoading }
}
